import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { environment } from '@/firebase/init'
import { getAuth, onAuthStateChanged } from 'firebase/auth'

Vue.config.productionTip = false

Vue.use(vuetify, {
  iconfont: 'mdi' || 'fa'
})

Vue.mixin({
  data() {
    return {
      environment: environment
    }
  },
  methods: {
    go: (route, params) => {
      let link = router.resolve({ name: route })
      if (link.resolved.matched.length > 0) {
        router.push({ name: route, params: params }).catch(error => {
          if (error.name != "NavigationDuplicated" && error.name != 'Error') {
            console.log('ERROR', error)
            // throw error;
          }
        })
      } else {
        router.push({ name: 'NotFound' })
      }
    },
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')